import React from 'react';
import { CountdownBanner } from './components/CountdownBanner';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { MethodIntro } from './components/MethodIntro';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { SummarySection } from './components/SummarySection';
import { FooterSection } from './components/FooterSection';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 antialiased selection:bg-yellow-200 selection:text-gray-900" data-id="element-0">
      <CountdownBanner data-id="element-1" />

      <main className="flex flex-col w-full overflow-hidden" data-id="element-2">
        <HeroSection data-id="element-3" />
        <PainSection data-id="element-4" />
        <MethodIntro data-id="element-5" />
        <TomosSection data-id="element-6" />
        <BonusSection data-id="element-7" />
        <TestimonialsSection data-id="element-8" />
        <PricingSection data-id="element-9" />
        <GuaranteeSection data-id="element-10" />
        <SummarySection data-id="element-11" />
      </main>

      <FooterSection data-id="element-12" />

      <SocialProofPopup data-id="element-13" />
    </div>;
}